/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import FacilityService from "../../services/FacilityService";
import UserService from "../../services/UserService";
import {If} from "../../utils/Controls";
import {AntdPaging, AntdSelect, AntdTag} from "../../utils/Antd";
import util from "../../utils/util";
import Tabs, {PageHeading} from "./Tabs";
import edit from "../assets/icons/pen-to-square-solid.svg"
import xmark from "../assets/icons/circle-xmark-solid.svg"

import { trailCreate, trailUpdate, trailDelete, TRAIL_MODULES } from '../../utils/activityTrail';
import{
    Input,
    Button,
    message,
    Modal,
    Select,
} from 'antd';
import{
    ExclamationCircleOutlined,
} from '@ant-design/icons';
const {confirm}=Modal;

export default function User() {
   
    const [result, setResult]=useState({data:[], page:{}});
    const [result2, setResult2]=useState({data:[], page:{}});
    const sdataRef=useRef({p: 1, ps: 25});
    const formRef=useRef();
    const [roles, setRoles] = useState([]);
    
    const isNational = util.isNational();
    const [programs, setPrograms] = useState([]);
    // Permission checks
    const canAdd    = util.canAdd('manage_roles_users');
    const canEdit   = util.canEdit('manage_roles_users');
    const canDelete = util.canDelete('manage_roles_users');
    const canExport = util.canExport('manage_roles_users'); 
    const list=(p, ps)=>{
        sdataRef.current.p=p || 1;
        sdataRef.current.ps=ps || sdataRef.current.ps;
        util.showLoader();

        UserService.users(sdataRef.current).then(({data})=>{
            setResult(data.result);
        }).catch(e => {
            message.error(e.message);
        }).finally(()=>{
            util.hideLoader();
        })
       
       
        UserService.usersCount(sdataRef.current).then(({data})=>{
            setResult2(data.result);
        }).catch(e => {
            message.error(e.message);
        }).finally(()=>{
            util.hideLoader();
        })
    }
    

    const deleteRecord=(id)=>{
        message.destroy();
        confirm({
            title: 'Do you Want to delete this user?',
            icon: <ExclamationCircleOutlined />,
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                util.showLoader();
             
                UserService.deleteUser(id).then(({data: delData})=>{
                    message.success(delData.message || 'Deleted');
                    const user = result.data.find(u => u.id === id);
                    trailDelete(TRAIL_MODULES.USER_MANAGEMENT,
                        `User: ${user?.fname ? `${user.fname} ${user.lname || ''}`.trim() : user?.username || String(id)}`, id,
                        { username: user?.username, role: user?.role });
                    list();
                }).catch(e => {
                    message.error(e.message);
                }).finally(() => {
                    util.hideLoader();
                })
            },
            onCancel() {
            },
        })
    }

    const [clients, setClients] = useState([]);
    useEffect(() => {
        FacilityService.all({ status: 1, include_me: 'Y' }).then(res => {
            let allClients = res.data.result.data.map(v => { return { id: v.id, name: v.business_name, is_national: v.is_national, is_me: v.is_me } });
            setClients(allClients);
        });
    }, []);

    

    
    useEffect(() => {


        list();
        UserService.roles({all: true}).then(res=>{ setRoles([...res.data.result.data])});
        import('../../services/ProgramsService').then(({ default: ProgramsService }) => {
            ProgramsService.getPrograms().then(r => setPrograms(r.data?.data || []));
        });
        return () => { message.destroy()}
    },
        []);
    

        const blockStyle = {
            backgroundColor: 'rgba(173, 216, 230, 0.5)',
            border: '1px solid #ccc',
            padding: '10px',
            flex: '1 1 100px',
            textAlign: 'center',
            fontWeight:'bold',
            fontSize: '16px',
            margin:'10px',
          };
          const containerStyle = {
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            
          };
    
        return (
            <div className="page-content">
                <div className="page-head uc d-flex">
                    
                    <div className="my-auto">
                    <p style={{ fontSize: '20px', textAlign: 'center',fontWeight:'bold' }}>REGISTERED USERS</p>
                    <div style={containerStyle}>
        {result2.data.map((i, v) => (

        <div key={v} style={blockStyle}>
          
          <p>{i.role}</p>
          <p>{i.registered_users}</p>
        </div>
        
      ))}
    </div>
        
                        <PageHeading />
                    </div>
                    <div className="my-auto ml-auto"></div>
                </div>

                <div className="page-pad">
                    <div className="tabbable-custom">
                        <Tabs active="users" />
                        <div className="tab-content">
                            <div className="tab-pane fade1 show active">
                                {result.data.length > 0 &&
                                    <div className="text-secondary mb8">
                                        Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                                    </div>
                                }

                                <div className="d-flex tbl-search-head">
                                    <div className="my-auto">
                                        <SearchForm dataRef={sdataRef} onSearch={list} />
                                    </div>
                                    <div className="ml-auto my-auto">
                                        {canAdd && <Button type="primary" onClick={() => formRef.current.openForm()}><i className="fa fa-plus mr5"></i> Add New User</Button>}
                                    </div>
                                </div>

                                <If cond={result.data.length}>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-md table-striped table-hover m-0">
                                            <thead className="thead-light text-uppercase table-text-vmid">
                                                <tr>
                                                    <th className="w20">SN</th>
                                                    <th className="w150">First Name</th>
                                                    <th className="w150">Last Name</th>
                                                    <th className="w180">Role</th>
                                                    <th>Email</th>
                                                    <th className="w120">Mobile No.</th>
                                                    <th className="w100">Username</th>
                                                    <th className="w60">Status</th>
                                                    <th className="w120">Last Login</th>
                                                    {isNational ?(<th className="w60">Facility</th>):null}
                                                    <th className="w70"></th>
                                                </tr>
                                            </thead>
                                            <tbody className="table-text-top">
                                                {result.data.map((v, i) => (
                                                    <tr key={i}>
                                                        <td>{result.page.start + i + 1}.</td>
                                                        <td>{v.fname}</td>
                                                        <td>{v.lname}</td>
                                                        <td>{v.role}</td>
                                                        <td>{v.email}</td>
                                                        <td>{v.mobile}</td>
                                                        <td>{v.username}</td>
                                                    
                                                        <td className="nowrap">
                                                            {v.status ? (<AntdTag type="success">Active</AntdTag>) : (<AntdTag type="danger">Inactive</AntdTag>)}
                                                        </td>
                                                        <td style={{fontSize:11,color:'#64748b',whiteSpace:'nowrap'}}>
                                                            {v.last_login ? new Date(v.last_login).toLocaleString('en-GB',{day:'2-digit',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'}) : <span style={{color:'#ccc'}}>Never</span>}
                                                        </td>
                                                        <td>{v.facility}</td>
                                                        <td className="text-center">
                                                            <Button.Group size="small">
                                                                {canEdit && <Button type="default" onClick={() => formRef.current.openForm(v)}><img src={edit} alt='' className='mr5' height={15}/></Button>}
                                                                {canDelete && <Button type="default" onClick={() => deleteRecord(v.id)}><img src={xmark} alt='' className='mr5' height={15}/></Button>}
                                                            </Button.Group>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex tbl-foot-bx">
                                        <AntdPaging
                                            onChange={list}
                                            total={result.page.total_records}
                                            current={result.page.cur_page}
                                            pageSize={sdataRef.current.ps}
                                            showSizeChanger
                                        />
                                    </div>
                                </If>
                                <If cond={!result.data.length}>
                                    <div className="no-rec">No record found</div>
                                </If>
                            </div>
                        </div>
                    </div>
                </div>

                <AddForm
                    ref={formRef}
                    callback={list}
                    pageno={sdataRef.current.p}
                    roles={roles}
                    clients={clients}
                    programs={programs}
                />
            </div>
        )           
}

const SearchForm=(props)=>{
    let {dataRef, onSearch}=props;
    let [data, setData]=useState({ ...dataRef.current });
    const handleChange=(v, k)=>{
        data[k]=v;
        setData({ ...data });
    }
    useEffect(()=>{
        dataRef.current={...data};
    }, [data]);

    useEffect(() => {
        setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps });
    }, [dataRef.current.p, dataRef.current.ps]);

    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                <div>
                    <Input placeholder="Search" allowClear value={data.k} onChange={e=>handleChange(e.target.value, 'k')} />
                </div>
                <div>
                    <Button type="primary" icon={<i className="fa fa-search fs13"></i>} onClick={()=>onSearch()}></Button>
                </div>
            </div>
        </form>
    )
}

const AddForm = forwardRef((props, ref) => {
    const programs = props.programs || [];
    
    
    let {callback, pageno, roles, clients} = props;
    const [showForm, setShowForm] = useState(false);
    let [data, setData] = useState({});

    const isNational = util.isNational();

    // Permission checks
    const canAdd    = util.canAdd('manage_roles_users');
    const canEdit   = util.canEdit('manage_roles_users');
    const canDelete = util.canDelete('manage_roles_users');
    const canExport = util.canExport('manage_roles_users');
    // user_scope: 'national' auto-assigns client_id=137, 'facility' requires facility pick
    const userScope = data.user_scope || 'national';
    const handleChange = (v, k) => {
        data[k] = v;
        setData({ ...data });
    }
    const save=()=>{
        message.destroy();
        util.showLoader();
        
        UserService.saveUser(data).then(({data: savedData}) => {
            message.success(savedData.message || 'Saved');
            const displayName = `${data.fname || ''} ${data.lname || ''}`.trim() || data.username || String(data.id);
            data.id
                ? trailUpdate(TRAIL_MODULES.USER_MANAGEMENT, `User: ${displayName}`, data.id,
                    { username: data.username, role: roles.find(r => r.id === data.role_id)?.name })
                : trailCreate(TRAIL_MODULES.USER_MANAGEMENT, `User: ${displayName}`, '',
                    { username: data.username, role: roles.find(r => r.id === data.role_id)?.name });
            callback(savedData.id?pageno:1);
            setShowForm(false);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        })
    }
    const closeForm=()=>{
        setShowForm(false);
    }

    useImperativeHandle(ref, ()=>({
        openForm(dtl){
            if (dtl) {
                // Editing: determine scope from existing client_id
                setData({ ...dtl, user_scope: dtl.client_id && dtl.client_id !== 137 ? 'facility' : 'national' });
            } else {
                setData({ status:'1', user_scope:'national', client_id: 137 });
            }
            setShowForm(true);
        }
    }));

  

    
        return (
            <Modal
                title={`${data.id ? 'Edit' : 'Add'} User`}
                visible={showForm}
                okText="Save"
                onOk={save}
                onCancel={closeForm}
                destroyOnClose
                maskClosable={false}
                width={800}
            >
                <form onSubmit={e => { e.preventDefault(); save() }} autoComplete="off" spellCheck="false">
                    <div className="">
                        <div className="row mingap">
                            <div className="col-md-4 form-group">
                                <label className="req">Role</label>
                                <div>
                                    <AntdSelect options={roles}
                                        value={data.role_id}
                                        onChange={v => { handleChange(v, 'role_id') }} />
                                </div>
                            </div>

                            <div className="col-md-4 form-group">
                                <label className="req">First Name</label>
                                <Input value={data.fname || ''} onChange={e => handleChange(e.target.value, 'fname')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="">Last Name</label>
                                <Input value={data.lname || ''} onChange={e => handleChange(e.target.value, 'lname')} />
                            </div>

                            <div className="col-md-4 form-group">
                                <label className="req">Email</label>
                                <Input value={data.email || ''} onChange={e => handleChange(e.target.value, 'email')} />
                            </div>

                            <div className="col-md-4 form-group">
                                <label className="req">Mobile</label>
                                <div>
                                    <Input value={data.mobile || ''} onChange={e => handleChange(e.target.value, 'mobile')} />
                                </div>
                            </div>

                            <div className="col-md-4 form-group">
                                <label className="req">Username</label>
                                <Input value={data.username || ''} onChange={e => handleChange(e.target.value, 'username')} />
                            </div>
                            <div className="col-md-4 form-group">
                                <label className="">Password</label>
                                <div>
                                    <Input onChange={e => handleChange(e.target.value, 'password')} />
                                </div>
                            </div>
                        
                            <div className="col-md-4 form-group">
                                <label className="req">Status</label>
                                <div>
                                    <AntdSelect
                                        options={[{ value: '1', label: "Active" }, { value: '0', label: "Inactive" }]}
                                        value={data.status}
                                        onChange={v => { handleChange(v, 'status') }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Scope</label>
                                <div>
                                    <Select value={data.scope_type || 'national'} style={{width:'100%'}}
                                        onChange={v => {
                                            handleChange(v, 'scope_type');
                                            if (v === 'national') { handleChange('', 'region'); handleChange(null, 'client_id'); handleChange(null, 'program_id'); }
                                            if (v === 'facility') { handleChange('', 'region'); handleChange(null, 'program_id'); }
                                            if (v === 'regional') { handleChange(null, 'client_id'); handleChange(null, 'program_id'); }
                                            if (v === 'program') { handleChange('', 'region'); handleChange(null, 'client_id'); }
                                        }}>
                                        <Select.Option value="national">National</Select.Option>
                                        <Select.Option value="regional">Regional</Select.Option>
                                        <Select.Option value="facility">Facility</Select.Option>
                                        <Select.Option value="program">Program</Select.Option>
                                    </Select>
                                </div>
                            </div>
                            {data.scope_type === 'program' && (
                            <div className="col-md-4 form-group">
                                <label>Program</label>
                                {/* Fixed: AntdSelect only renders from its `options` prop —
                                    it forwards `options` (defaulting to []) straight to the
                                    underlying antd Select, which ignores JSX <Option> children
                                    whenever `options` is present. The old code passed
                                    <AntdSelect.Option> children (which doesn't even exist as
                                    an export) and never passed `options`, so the dropdown
                                    always rendered empty regardless of what was in `programs`.
                                    Passing `options={programs}` matches how `roles`/`clients`
                                    are already wired above, and AntdSelect's own remap logic
                                    (v.id -> value, v.name -> label) handles the {id, name, ...}
                                    shape returned by ProgramsService.getPrograms() correctly. */}
                                <AntdSelect
                                    placeholder="Select program"
                                    options={programs}
                                    value={data.program_id}
                                    onChange={v => handleChange(v, 'program_id')}
                                />
                            </div>
                            )}
                            {(data.scope_type === 'regional' || (!data.scope_type && data.region)) && (
                            <div className="col-md-4 form-group">
                                <label>Region(s)</label>
                                <Select mode="multiple" style={{width:'100%'}}
                                    placeholder="Select region(s)"
                                    value={data.regions ? (typeof data.regions === 'string' ? JSON.parse(data.regions) : data.regions) : (data.region ? [data.region] : [])}
                                    onChange={v => {
                                        handleChange(v.length === 1 ? v[0] : v[0] || '', 'region');
                                        handleChange(JSON.stringify(v), 'regions');
                                    }}>
                                    {['Hhohho','Manzini','Lubombo','Shiselweni'].map(r => (
                                        <Select.Option key={r} value={r}>{r}</Select.Option>
                                    ))}
                                </Select>
                            </div>
                            )}
                            {isNational && data.scope_type !== 'regional' && (
                            <>
                            <div className="col-md-12 form-group">
                                <label style={{fontWeight:600,marginRight:12}}>User Type:</label>
                                <label style={{marginRight:16,cursor:'pointer'}}>
                                    <input type="radio" name="user_scope" value="national"
                                        checked={userScope === 'national'}
                                        onChange={() => { data.user_scope = 'national'; data.client_id = 137; setData({...data}); }}
                                        style={{marginRight:4}}/>
                                    National User <span style={{fontSize:11,color:'#888'}}>(no specific facility)</span>
                                </label>
                                <label style={{cursor:'pointer'}}>
                                    <input type="radio" name="user_scope" value="facility"
                                        checked={userScope === 'facility'}
                                        onChange={() => { data.user_scope = 'facility'; data.client_id = null; setData({...data}); }}
                                        style={{marginRight:4}}/>
                                    Facility User <span style={{fontSize:11,color:'#888'}}>(assigned to a specific facility)</span>
                                </label>
                            </div>
                            {userScope === 'facility' && (
                            <div className="col-md-4 form-group">
                                <label className="req">Facility</label>
                                <div>
                                    <AntdSelect
                                        placeholder="Select Facility"
                                        allowClear
                                        showSearch
                                        options={clients}
                                        value={data.client_id}
                                        onChange={v => {
                                            data.item_id = null;
                                            handleChange(v, 'client_id');
                                        }}
                                    ></AntdSelect>
                                </div>
                            </div>
                            )}
                            </>
                            )}

                        </div>
                    </div>

                </form>
            </Modal>
        )
    
    
})
